import React, { useContext, useState } from 'react';
import { GetPermissionProfileAtom } from '../../store/permissionProfileAtom';
import LogicContext from '../../Context/LogicContext';
import { permissionProfileService } from '../../services/permissionProfile.service';
import { useNavigate } from 'react-router-dom';



const AddPermissionProfilePage = () => {
  const [profileName, setProfileName] = useState('');
  const [selectedModuleId, setSelectedModuleId] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
   const  getProfileAtom = GetPermissionProfileAtom();
     const logicContext = useContext(LogicContext);
      const navigate = useNavigate();


      const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 1. Validation check
    if (!profileName.trim() || selectedModuleId === 0) {
      return logicContext.showToast('Please fill in all required fields', 'error');
    }

    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      // API Payload
      const payload = {
        profile_name: profileName.trim(), // Use trim() to avoid whitespace-only names
        module_id: selectedModuleId,
        option: 1
      };

      // 2. Consistent Async/Await pattern
      const res = await permissionProfileService.submitProfile(payload);
      
      // Navigate deep into the nested data safely
      const rawData = res.data?.[0] || res.data?.result_status?.[0];
      const response = logicContext.httpResponseManager(rawData);

      if (response.message_id === 1) {
        logicContext.showToast(response.message_text || 'Profile created successfully!', 'success');
        
        // Reset form ONLY on success
        setProfileName('');
        setSelectedModuleId(0);
        
        sessionStorage.setItem('reloadPage', 'true');
        navigate(-1);
      } else {
        logicContext.showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (err) {
      console.error('Submission Error:', err);
      logicContext.showToast('An unexpected error occurred', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-6">
          <h1 className="text-3xl font-bold text-white tracking-tight">Create New Profile</h1>
          <p className="text-blue-100 mt-1">Fill in the details below</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-8">
          {/* Profile Name Input */}
          <div>
            <label htmlFor="profile_name" className="block text-sm font-medium text-gray-700 mb-2">
              Profile Name <span className="text-red-500">*</span>
            </label>
            <input
              id="profile_name"
              type="text"
              value={profileName}
              onChange={(e) => setProfileName(e.target.value)}
              required
              placeholder="Enter profile name"
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-900 placeholder:text-gray-400"
            />
          </div>

          {/* Module Select */}
          <div>
            <label htmlFor="module_id" className="block text-sm font-medium text-gray-700 mb-2">
              Module <span className="text-red-500">*</span>
            </label>
            <select
              id="module_id"
              value={selectedModuleId}
              onChange={(e) => setSelectedModuleId(Number(e.target.value))}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-gray-900 bg-white"
            >
              {getProfileAtom.module_without_all.map((module) => (
                <option key={module.module_id} value={module.module_id}>
                  {module.module_name}
                </option>
              ))}
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting || !profileName.trim()}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold py-4 px-6 rounded-2xl transition-all flex items-center justify-center gap-3 text-lg shadow-sm"
          >
            {isSubmitting ? (
              <>
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
                Submitting...
              </>
            ) : (
              'Create Profile'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPermissionProfilePage;